import React, { useState, useEffect } from 'react';
import TestiLikeComment from '../components/ui/TestiLikeComment';
import ZoomImage from '../components/ui/ZoomImage';
import Avatar from '../components/ui/Avatar';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const FLAG = (code) => `https://flagcdn.com/24x18/${code}.png`;


const decades = {
  '1960s': [1963, 1965, 1968, 1969],
  '1970s': [1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979],
  '1980s': [1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989],
  '1990s': [1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
  '2000s': [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009],
};

const pays = [
  { code: 'all', label: 'Tous', flag: null },
  { code: 'fr', label: 'France', flag: 'fr' },
  { code: 'us', label: 'États-Unis', flag: 'us' },
  { code: 'uk', label: 'Royaume-Uni', flag: 'gb' },
  { code: 'de', label: 'Allemagne', flag: 'de' },
  { code: 'it', label: 'Italie', flag: 'it' },
  { code: 'jp', label: 'Japon', flag: 'jp' },
  { code: 'es', label: 'Espagne', flag: 'es' },
  { code: 'other', label: '+ Autres', flag: null },
];

const categories = [
  { id: 'all', label: 'Toutes' },
  { id: 'hotel', label: '🏨 Hôtel' },
  { id: 'rue', label: '🚗 Dans la rue' },
  { id: 'aeroport', label: '✈️ Aéroport' },
  { id: 'neverland', label: '🎠 Neverland' },
  { id: 'restaurant', label: '🍽️ Restaurant / café' },
  { id: 'tournage', label: '🎬 Tournage' },
  { id: 'hopital', label: '🏥 Hôpital / visite' },
  { id: 'backstage', label: '🎪 Backstage' },
  { id: 'shopping', label: '🛍️ Shopping' },
  { id: 'fetes', label: '🥂 Fêtes et événements privés' },
];

const fakeTestimonials = [
  { id: 1, name: 'Marie-Laure T.', initials: 'ML', flagCode: 'fr', country: 'France', city: 'Paris', year: 1997, cat: 'hotel', media: 'photo', text: "Je travaillais à la réception de l'hôtel. Il est descendu à 3h du matin pour demander un thé. On a parlé 20 minutes. Il était timide, doux, et curieux de tout." },
  { id: 2, name: 'Jean-Daniel M.', initials: 'JD', flagCode: 'ch', country: 'Suisse', city: 'Genève', year: 1996, cat: 'rue', media: 'none', text: "Sa limousine s'est arrêtée devant moi. La vitre s'est baissée. Il a vu mon t-shirt avec sa photo et a éclaté de rire. Il a signé mon bras avec un marqueur." },
  { id: 3, name: 'Amira K.', initials: 'AK', flagCode: 'ma', country: 'Maroc', city: 'Los Angeles', year: 2001, cat: 'neverland', media: 'video', text: "J'étais enfant malade invitée à Neverland avec d'autres enfants. Il nous a accueillis personnellement et a passé toute l'après-midi avec nous." },
  { id: 4, name: 'Peter H.', initials: 'PH', flagCode: 'de', country: 'Allemagne', city: 'Munich', year: 1997, cat: 'aeroport', media: 'photo', text: "Je l'ai reconnu à l'aéroport de Munich. Il était entouré mais m'a fait signe d'approcher. Il a pris le temps de poser pour une photo et de signer mon passeport." },
  { id: 5, name: 'Sophie L.', initials: 'SL', flagCode: 'fr', country: 'France', city: 'Cannes', year: 1993, cat: 'restaurant', media: 'none', text: "Je l'ai croisé dans un restaurant à Cannes pendant le festival. Il mangeait seul, tranquillement. Il a été d'une gentillesse incroyable." },
];

const featured = {
  name: 'Roberto S.', initials: 'RS', flagCode: 'it', country: 'Italie', city: 'New York', year: 1993,
  text: "Il était dans un café de New York, sans gardes du corps, avec juste un ami. Il portait des lunettes de soleil et un chapeau. Il m'a regardé, a souri, et m'a dit 'have a nice day' avec cette voix inimitable. Trente secondes. Une vie entière.",
};

const btnActive = { border: '2px solid #8b1a2a', borderRadius: '8px', padding: '7px 14px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial,sans-serif', background: '#8b1a2a', color: '#fff', display: 'inline-flex', alignItems: 'center', gap: '6px' };
const btnInactive = { border: '2px solid #8b1a2a', borderRadius: '8px', padding: '7px 14px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial,sans-serif', background: '#fff', color: '#1a1010', display: 'inline-flex', alignItems: 'center', gap: '6px' };
const catActive = { border: '2px solid #8b1a2a', borderRadius: '8px', padding: '7px 14px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial,sans-serif', background: '#8b1a2a', color: '#fff' };
const catInactive = { border: '2px solid #c49090', borderRadius: '8px', padding: '7px 14px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial,sans-serif', background: '#fff', color: '#4a3030' };

export default function Rencontres() {
  const { user } = useAuth();
  const token = localStorage.getItem('mjtoken');
  const [activePay, setActivePay] = useState('all');
  const [activeCat, setActiveCat] = useState('all');
  const [activeDec, setActiveDec] = useState(null);
  const [activeYear, setActiveYear] = useState(null);
  const [activeMedia, setActiveMedia] = useState('all');
  const [search, setSearch] = useState('');
  const [openId, setOpenId] = useState(null);

  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => {
    fetch('/api/testimonials?section=rencontre')
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setTestimonials(data); })
      .catch(() => {});
  }, []);

  const mapped = testimonials.map(t => ({
    ...t,
    id: t._id,
    name: t.authorName,
    initials: (t.authorName || 'A').slice(0, 2).toUpperCase(),
    photo: t.authorPhoto || '',
    avatar: t.authorAvatar || '',
    flagCode: (t.location?.country || t.authorCountry || 'fr').toLowerCase().slice(0, 2),
    country: t.authorCountry || t.location?.country || '',
    city: t.location?.city || '',
    year: t.eventDate || '',
    cat: 'message',
    media: t.photos?.length > 0 ? 'photo' : (t.videos?.length > 0 ? 'video' : 'none'),
    videoUrl: t.videoUrl || '',
    text: t.content,
  }));

  const filtered = mapped.filter(t => {
    if (activePay !== 'all' && activePay !== 'other' && t.flagCode !== activePay && !(activePay === 'uk' && t.flagCode === 'gb')) return false;
    if (activeCat !== 'all' && t.cat !== activeCat) return false;
    if (activeMedia === 'photo' && t.media !== 'photo') return false;
    if (activeMedia === 'video' && t.media !== 'video') return false;
    if (activeMedia === 'none' && t.media !== 'none') return false;
    if (activeYear && t.year !== activeYear) return false;
    if (search && !t.text.toLowerCase().includes(search.toLowerCase()) && !t.name.toLowerCase().includes(search.toLowerCase()) && !t.city.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const open = mapped.find(t => t.id === openId);

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', fontFamily: 'Arial,sans-serif' }}>

      <div style={{ background: '#fff', padding: '28px 40px', borderBottom: '2px solid #c49090' }}>
        <p style={{ fontSize: '12px', letterSpacing: '0.15em', color: '#8b1a2a', marginBottom: '6px', fontWeight: '700' }}>— TÉMOIGNAGES</p>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: '28px', color: '#1a1010', fontWeight: '400', marginBottom: '8px' }}>
          🤝 Rencontres & <em style={{ color: '#8b1a2a', fontStyle: 'italic' }}>hasards</em>
        </h1>
        <p style={{ fontSize: '13px', color: '#4a3030', lineHeight: '1.7', maxWidth: '500px', marginBottom: '14px' }}>
          Ces fans l'ont croisé dans la vraie vie — hors des concerts, hors des cérémonies. Dans un couloir d'hôtel, sur un trottoir, dans un café.
        </p>
        <Link to="/temoigner"><button style={{ ...btnActive, padding: '10px 22px' }}>✦ Partager ma rencontre</button></Link>
      </div>

      {/* FILTRES PAYS */}
      <div style={{ background: '#f5eeeb', borderBottom: '2px solid #c49090', padding: '14px 40px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', color: '#1a1010', fontWeight: '700', minWidth: '70px' }}>Pays :</span>
          {pays.map(p => (
            <button key={p.code} onClick={() => setActivePay(p.code)} style={activePay === p.code ? btnActive : btnInactive}>
              {p.flag && <img src={FLAG(p.flag)} alt={p.label} style={{ width: '20px', height: '15px', borderRadius: '2px', objectFit: 'cover' }} />}
              {p.label}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', color: '#1a1010', fontWeight: '700', minWidth: '70px' }}>Médias :</span>
          {[{ id: 'all', label: 'Tous' }, { id: 'photo', label: '📸 Avec photo' }, { id: 'video', label: '📹 Avec vidéo' }, { id: 'none', label: '✍️ Texte seul' }].map(m => (
            <button key={m.id} onClick={() => setActiveMedia(m.id)} style={activeMedia === m.id ? btnActive : btnInactive}>{m.label}</button>
          ))}
        </div>
      </div>

      {/* CATÉGORIES */}
      <div style={{ background: '#fff', borderBottom: '2px solid #c49090', padding: '14px 40px' }}>
        <div style={{ fontSize: '13px', color: '#1a1010', fontWeight: '700', marginBottom: '10px' }}>Type de rencontre :</div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {categories.map(c => (
            <button key={c.id} onClick={() => setActiveCat(c.id)} style={activeCat === c.id ? catActive : catInactive}>{c.label}</button>
          ))}
        </div>
      </div>

      {/* FRISE */}
      <div style={{ background: '#fff', borderBottom: '2px solid #c49090', padding: '14px 40px' }}>
        <div style={{ fontSize: '13px', color: '#1a1010', fontWeight: '700', marginBottom: '10px' }}>Frise chronologique :</div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button onClick={() => { setActiveDec(null); setActiveYear(null); }} style={!activeDec ? btnActive : btnInactive}>Tout</button>
          {Object.keys(decades).map(dec => (
            <button key={dec} onClick={() => { setActiveDec(activeDec === dec ? null : dec); setActiveYear(null); }}
              style={activeDec === dec ? btnActive : btnInactive}>{dec}</button>
          ))}
        </div>
        {activeDec && (
          <div style={{ marginTop: '10px', padding: '12px 16px', background: '#f5eeeb', borderRadius: '8px', border: '1px solid #c49090', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {decades[activeDec].map(yr => (
              <button key={yr} onClick={() => setActiveYear(activeYear === yr ? null : yr)}
                style={activeYear === yr ? { ...btnActive, fontSize: '12px', padding: '5px 12px' } : { ...btnInactive, border: '2px solid #c49090', fontSize: '12px', padding: '5px 12px' }}>
                {yr}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* RECHERCHE */}
      <div style={{ background: '#f5eeeb', borderBottom: '2px solid #c49090', padding: '12px 40px' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Rechercher un mot, un lieu, un nom…"
          style={{ width: '100%', border: '2px solid #8b1a2a', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#1a1010', outline: 'none', background: '#fff', fontFamily: 'Arial,sans-serif' }} />
      </div>

      {/* CONTENU */}
      <div style={{ padding: '24px 40px' }}>
        {open ? (
          <div style={{ background: '#f5eeeb', border: '2px solid #c49090', borderRadius: '12px', padding: '24px', marginBottom: '24px' }}>
            <button onClick={() => setOpenId(null)} style={{ fontSize: '13px', color: '#8b1a2a', background: 'none', border: 'none', cursor: 'pointer', marginBottom: '14px', display: 'block', fontWeight: '700' }}>← Retour</button>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
              <Avatar photo={open.photo} avatar={open.avatar} name={open.name} initials={open.initials} size={40} bg="#8b1a2a" color="#fff" />
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '3px' }}>
                  <img src={FLAG(open.flagCode)} alt="" style={{ width: '20px', height: '15px', borderRadius: '2px' }} />
                  <span style={{ fontSize: '15px', fontWeight: '700', color: '#1a1010' }}>{open.name}</span>
                </div>
                <div style={{ fontSize: '12px', color: '#6a5050' }}>{open.country} · {open.city} · {open.year}</div>
              </div>
            </div>
            <p style={{ fontSize: '15px', color: '#1a1010', lineHeight: '1.9', fontStyle: 'italic', fontFamily: 'Georgia,serif' }}>"{open.text}"</p>
            {open.photos?.length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 14 }}>
                {open.photos.map((p, i) => (
                  <ZoomImage key={i} src={p} style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8, border: '1px solid #e8d5d0' }} />
                ))}
              </div>
            )}
            {open.videos?.length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 14 }}>
                {open.videos.map((v, i) => (
                  <video key={i} src={v} controls style={{ width: 240, borderRadius: 8, border: '1px solid #e8d5d0' }} />
                ))}
              </div>
            )}
            {open.videoUrl && (() => {
              const u = open.videoUrl; let embed = '';
              const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
              const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
              if (yt) embed = 'https://www.youtube.com/embed/' + yt[1];
              else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1];
              return embed
                ? <div style={{ marginTop: 14 }}><iframe title="video" src={embed} style={{ width: '100%', maxWidth: 420, aspectRatio: '16 / 9', border: '1px solid #e8d5d0', borderRadius: 8 }} allow="accelerometer; autoplay; encrypted-media; picture-in-picture; clipboard-write" allowFullScreen /></div>
                : <a href={u} target="_blank" rel="noreferrer" style={{ display: 'inline-block', marginTop: 14, fontSize: 13, color: '#8b1a2a' }}>Voir la video</a>;
            })()}
            <TestiLikeComment
              testimonialId={open.id || open._id}
              initialLikes={open.likes?.length || 0}
              likesList={open.likes || []}
              initialComments={open.comments || []}
              currentUserId={user?._id || user?.id}
              token={token}
            />
          </div>
        ) : (
          <>
            <p style={{ fontSize: '12px', letterSpacing: '0.12em', color: '#8b1a2a', fontWeight: '700', marginBottom: '8px' }}>— COUP DE CŒUR</p>
            <div style={{ background: '#f5eeeb', border: '2px solid #c49090', borderRadius: '12px', padding: '20px', marginBottom: '24px' }}>
              <p style={{ fontSize: '15px', color: '#1a1010', lineHeight: '1.8', fontStyle: 'italic', fontFamily: 'Georgia,serif', marginBottom: '14px' }}>"{featured.text}"</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: '#8b1a2a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', color: '#fff', fontWeight: '700' }}>{featured.initials}</div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '2px' }}>
                    <img src={FLAG(featured.flagCode)} alt="" style={{ width: '20px', height: '15px', borderRadius: '2px' }} />
                    <span style={{ fontSize: '14px', fontWeight: '700', color: '#1a1010' }}>{featured.name}</span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#6a5050' }}>{featured.country} · {featured.city}, {featured.year}</div>
                </div>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '14px' }}>
              {filtered.map(t => (
                <div key={t.id} onClick={() => setOpenId(t.id)} style={{ background: '#fff', border: '2px solid #c49090', borderRadius: '10px', padding: '16px', cursor: 'pointer', transition: 'border-color 0.15s', display: 'flex', gap: '14px', alignItems: 'flex-start' }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = '#8b1a2a'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = '#c49090'}>
                  {(() => {
                    let src = '', vid = false;
                    if (t.photos?.length > 0) src = t.photos[0];
                    else if (t.videos?.length > 0) { src = t.videos[0].replace(/\.(mp4|mov|avi|mkv|webm|m4v)(\?.*)?$/i, '.jpg'); vid = true; }
                    else if (t.videoUrl) { vid = true; const yt = t.videoUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/); if (yt) src = 'https://img.youtube.com/vi/' + yt[1] + '/hqdefault.jpg'; }
                    if (!src && !vid) return null;
                    return (
                      <div style={{ position: 'relative', width: 110, height: 110, flexShrink: 0 }}>
                        {src
                          ? <img src={src} alt="" style={{ width: 110, height: 110, objectFit: 'cover', borderRadius: 8 }} />
                          : <div style={{ width: 110, height: 110, borderRadius: 8, background: '#1a1010', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 24 }}>{'\u25b6'}</div>}
                        {vid && src && <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div style={{ width: 32, height: 32, borderRadius: '50%', background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'\u25b6'}</div></div>}
                      </div>
                    );
                  })()}
                  <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <Avatar photo={t.photo} avatar={t.avatar} name={t.name} initials={t.initials} size={34} bg="#8b1a2a" color="#fff" />
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '2px' }}>
                        <img src={FLAG(t.flagCode)} alt="" style={{ width: '18px', height: '13px', borderRadius: '2px' }} />
                        <span style={{ fontSize: '13px', fontWeight: '700', color: '#1a1010' }}>{t.name}</span>
                      </div>
                      <div style={{ fontSize: '12px', color: '#6a5050' }}>{t.country} · {t.city}, {t.year}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '5px', marginBottom: '8px', flexWrap: 'wrap' }}>
                    {categories.find(c => c.id === t.cat)?.label && <span style={{ fontSize: '12px', padding: '3px 9px', borderRadius: '6px', background: '#f5eeeb', color: '#8b1a2a', border: '1px solid #c49090', fontWeight: '600' }}>{categories.find(c => c.id === t.cat)?.label}</span>}
                    {t.media === 'photo' && <span style={{ fontSize: '12px', padding: '3px 9px', borderRadius: '6px', background: '#e8f5e9', color: '#1a6a30', border: '1px solid #80c080', fontWeight: '600' }}>📸 Photo</span>}
                    {t.media === 'video' && <span style={{ fontSize: '12px', padding: '3px 9px', borderRadius: '6px', background: '#e8f0ff', color: '#2a3a8a', border: '1px solid #8090d0', fontWeight: '600' }}>📹 Vidéo</span>}
                  </div>
                  <p style={{ fontSize: '12px', color: '#1a1010', lineHeight: '1.6', fontStyle: 'italic', fontFamily: 'Georgia,serif', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', marginBottom: '10px' }}>
                    "{t.text}"
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '12px', color: '#6a5050', fontWeight: '600' }}>📍 {t.city}</span>
                    <span style={{ fontSize: '12px', color: '#8b1a2a', fontWeight: '700' }}>Lire la suite →</span>
                  </div>
                  <TestiLikeComment
                    testimonialId={t.id || t._id}
                    initialLikes={t.likes?.length || 0}
                    likesList={t.likes || []}
                    initialComments={t.comments || []}
                    currentUserId={user?._id || user?.id}
                    token={token}
                  />
                  </div>
                </div>
              ))}
              {filtered.length === 0 && (
                <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px', color: '#9a8080', fontSize: '14px' }}>Aucun témoignage pour ces filtres.</div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
